import email from "./email.json";
import entity from "./entity.json";
import refundPolicy from "./refundPolicy.json";

export default {
    email,
    entity,
    refundPolicy,
};
